module.exports = __webpack_public_path__ + "img/visa.bbde7cb9.svg";